module.exports = __webpack_public_path__ + "static/media/455.04966bf9.webp";